<template>
  <v-container >
 <!-- <div v-if="showcheckout">
   <v-row justify="center">
      <v-col cols="12" md="8">
        <v-card elevation="0">
          <v-card-text>
            <div id="checkout"></div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    </div> -->
    <!-- v-else -->
    <div >
    <v-row class="mb-16 ml-4 mr-4" justify="center" v-bind:style="{ align:'center'}" :class="{'mt-16': !$vuetify.breakpoint.smAndDown }">
      <v-col class="btngetstart_paragraph" align="center" justify="center"  cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
       <h1 class="display-6 fw-bold lh-1 mb-3 section-title " v-bind:style="{ fontSize:'38px' }">
            {{this.lg_header_feature.pricingplans}}
          </h1>
           <h5 class="display-6 fw-bold lh-1 mb-3" v-bind:style="{ fontSize:'16px',fontWeight:'300 !important',color:'#215295' }" >
            {{this.lg_header_feature.title2}}
          </h5>
           <h5 class="display-6 fw-bold lh-1 mb-3" v-bind:style="{ fontSize:'16px',fontWeight:'300 !important',color:'#215295' }">
            {{this.lg_header_feature.title1}}
          </h5>
      </v-col>
    </v-row>

    <v-row class="align-center justify-center mb-6">
     <v-btn-toggle
    v-model="billing"
    mandatory
     background-color="white"
  class="billing-toggle elevation-1"
  >
    <v-btn value="monthly" class="billing-btn" text>{{ this.lg_header_feature.monthly }}</v-btn>
    <v-btn value="annually" class="billing-btn" text>{{ this.lg_header_feature.yearly }}</v-btn>
  </v-btn-toggle>
   </v-row>

      <v-row class="align-center justify-center">
        <!-- plan free -->
      <v-col  cols="12" sm="10" md="4" lg="4">  
        <v-card color="#FFFFFF" class="mx-6 mx-md-0 hover-zoom card-outter" elevation="4" style="border-radius:30px;" :min-height="card_height">
          <v-card-text align="center" justify="center" class="px-8">
            <v-row>
           <v-col justify="left" align="left" cols="12">
            <h3 v-bind:style="{ fontSize:'20px',fontWeight:'600 !important',color:'#000000' }">{{ this.lg_header_feature.pricesubtitlefree }}</h3> 
             </v-col>
        </v-row>

          <v-row>
           <v-col justify="left" align="left" cols="12">
            <h3 v-if="billing=='monthly'" v-bind:style="{ fontSize:'24px',fontWeight:'600 !important',color:'#000000' }">฿ 0
              <sapn  v-bind:style="{ fontSize:'14px',color:'#215295' }">{{ this.lg_header_feature.subtitlefree }}</sapn>
            </h3>
            <h3 v-else v-bind:style="{ fontSize:'24px',fontWeight:'600 !important',color:'#000000' }">฿ 0
              <sapn  v-bind:style="{ fontSize:'14px',color:'#215295' }">{{ this.lg_header_feature.subtitlefree_2 }}</sapn>
            </h3>  
          </v-col>
        </v-row>

          <v-row>
           <v-col justify="center" align="center" cols="12">
            <h5 v-bind:style="{ fontSize:'16px',fontWeight:'200 !important',color:'#215295' }">{{ this.lg_header_feature.freeplan_details }}</h5> 
         </v-col>
        </v-row>

         <!-- <v-row>
           <v-col justify="center" align="center" cols="12">
            <h3 v-bind:style="{ fontSize:'18px',fontWeight:'600 !important',color:'#000000' }">{{ this.lg_header_feature.subtitlefree }}</h3> 
         </v-col>
        </v-row> -->

            <v-divider class="mt-2" color="#ffffff" style="border-top:1px solid #ffffff;"></v-divider>

             <!-- <v-row class="mt-2">
           <v-col justify="center" align="center" cols="12">
           <v-btn
                class="rounded-pill"
                v-bind:style="{ fontSize:'14px',fontWeight:'600 !important',color:'#000000' }"
                 height="30"
              >
              {{ this.lg_header_feature.explore_features }}
              </v-btn>
        </v-col>
        </v-row> -->

          <v-row class="mt-2">
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'16px',fontWeight:'500 !important',color:'#215295',textIndent: '-30px',paddingLeft: '40px' }">
            <v-icon color="#215295">mdi-checkbox-marked-circle</v-icon> {{ this.lg_header_feature.titlefreeplandetails1 }}
        </v-col>
        </v-row>
          <v-row >
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'16px',fontWeight:'500 !important',color:'#215295',textIndent: '-30px',paddingLeft: '40px' }">
            <v-icon color="#215295">mdi-checkbox-marked-circle</v-icon> {{ this.lg_header_feature.titlefreeplandetails2 }}
        </v-col>
        </v-row>
          <v-row >
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'16px',fontWeight:'500 !important',color:'#215295',textIndent: '-30px',paddingLeft: '40px' }">
            <v-icon color="#215295">mdi-checkbox-marked-circle</v-icon> {{ this.lg_header_feature.titlefreeplandetails3 }}
        </v-col>
        </v-row>

       <v-row class="mt-2" justify="center" align="center">
        <v-card-actions class="card-actions">
          <v-row>
           <v-col justify="center" align="center" cols="12">
           <v-btn
                 elevation="2"
                 v-bind:style="{ fontSize:'14px',fontWeight:'600 !important',backgroundColor:'#215295 !important',color:'#ffffff',marginBottom:'10px' }"
                 height="35"
                 width="200"
                 class="slide-btn"
                  @click="onClickMenu('/register-account')"
              >
              {{ this.lg_header_feature.btn_signup }}
              </v-btn>
        </v-col>
        </v-row>
</v-card-actions>
</v-row>

          </v-card-text>
        </v-card>
      </v-col>

 <!-- plan pro -->
      <v-col  cols="12"  sm="10" md="4" lg="4" >
        <v-card outlined color="#FFFFFF" class="mx-6 mx-md-0 hover-zoom card-outter" elevation="4" style="border-radius:30px;" :min-height="card_height">
          <v-card-text align="center" justify="center" class="px-8">
            <v-row>
           <v-col justify="left" align="left" cols="12">
            <h3 v-bind:style="{ fontSize:'20px',fontWeight:'600 !important',color:'#000000' }">{{ this.lg_header_feature.titleproplan }}</h3> 
             </v-col>
        </v-row>

          <v-row>
           <v-col justify="left" align="left" cols="12">
            <h3 v-if="billing=='monthly'" v-bind:style="{ fontSize:'24px',fontWeight:'600 !important',color:'#000000' }">฿ 390
              <sapn  v-bind:style="{ fontSize:'14px',color:'#215295' }">{{ this.lg_header_feature.subtitlefree }}</sapn>
            </h3> 
            <h3 v-else v-bind:style="{ fontSize:'24px',fontWeight:'600 !important',color:'#000000' }">฿ 4,680
              <sapn  v-bind:style="{ fontSize:'14px',color:'#215295' }">{{ this.lg_header_feature.subtitlefree_2 }}</sapn>
            </h3> 
          </v-col>
        </v-row>

         <v-row>
           <v-col justify="center" align="center" cols="12">
            <h5 v-bind:style="{ fontSize:'16px',fontWeight:'200 !important',color:'#215295' }">{{ this.lg_header_feature.proplan_details }}</h5> 
         </v-col>
        </v-row>

         <!-- <v-row>
           <v-col justify="center" align="center" cols="12">
            <h3 v-bind:style="{ fontSize:'18px',fontWeight:'600 !important',color:'#000000' }">{{ this.lg_header_feature.subtitlefree }}</h3> 
         </v-col>
        </v-row> -->

            <v-divider class="mt-2" color="#ffffff" style="border-top:1px solid #ffffff;"></v-divider>

             <!-- <v-row class="mt-2">
           <v-col justify="center" align="center" cols="12">
           <v-btn
                class="rounded-pill"
                v-bind:style="{ fontSize:'14px',fontWeight:'600 !important',color:'#000000' }"
                 height="30"
              >
              {{ this.lg_header_feature.explore_features }}
              </v-btn>
        </v-col>
        </v-row> -->

          <v-row class="mt-2">
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'16px',fontWeight:'500 !important',color:'#215295',textIndent: '-30px',paddingLeft: '40px' }">
            <v-icon color="#215295">mdi-checkbox-marked-circle</v-icon> {{ this.lg_header_feature.titleproplanoptions1 }}
        </v-col>
        </v-row>
          <v-row >
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'16px',fontWeight:'500 !important',color:'#215295',textIndent: '-30px',paddingLeft: '40px' }">
            <v-icon color="#215295">mdi-checkbox-marked-circle</v-icon> {{ this.lg_header_feature.titleproplanoptions2 }}
        </v-col>
        </v-row>
          <v-row >
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'16px',fontWeight:'500 !important',color:'#215295',textIndent: '-30px',paddingLeft: '40px' }">
            <v-icon color="#215295">mdi-checkbox-marked-circle</v-icon> {{ this.lg_header_feature.titleproplanoptions3 }}
        </v-col>
        </v-row>
         <v-row >
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'16px',fontWeight:'500 !important',color:'#215295',textIndent: '-30px',paddingLeft: '40px' }">
            <v-icon color="#215295">mdi-checkbox-marked-circle</v-icon> {{ this.lg_header_feature.titleproplanoptions4 }}
        </v-col>
        </v-row>

          <v-row class="mt-2" justify="center" align="center">
        <v-card-actions class="card-actions">
         <v-row>
           <v-col justify="center" align="center" cols="12">
            <!-- @click="PaycheckoutPro('pro')" -->
            <v-btn
                 elevation="2"
                 outlined
                v-bind:style="{ fontSize:'14px',fontWeight:'600 !important',backgroundColor:'#ffffff !important',color:'#215295',marginBottom:'10px' }"
                height="35"
                width="200"
                class="slide-btn"
              >
              {{ this.lg_header_feature.coming_soon }}
              </v-btn>
        </v-col>
        </v-row>
        </v-card-actions>
        </v-row>
          </v-card-text>
        </v-card>
      </v-col>


       <!-- plan business -->
      <v-col  cols="12"  sm="10" md="4" lg="4">
        <v-card color="#ffffff" class="mx-6 mx-md-0 hover-zoom card-outter relative-card" elevation="4" style="border-radius:30px;" :min-height="card_height">
           <!-- <v-icon
    class="icon-top-right"
    color="#215295"
    size="40"
  >
    mdi-star-circle
  </v-icon> -->
   <v-btn
                 elevation="2"
                 
               v-bind:style="{ fontSize:'14px',fontWeight:'600 !important',backgroundColor:'#3173B5 !important',color:'#ffffff' }"
                height="25"
                width="120"
                class="icon-top-right rounded-pill"
              >
              {{ this.lg_header_feature.recommend }}
              </v-btn>
          <v-card-text align="center" justify="center" class="px-8">
            <v-row>
           <v-col justify="left" align="left" cols="12">
            <h3 v-bind:style="{ fontSize:'20px',fontWeight:'600 !important',color:'#000000' }">{{ this.lg_header_feature.titlebusinessplan }}</h3> 
             </v-col>
        </v-row>

          <v-row>
           <v-col justify="left" align="left" cols="12" >
            <h3 v-if="billing=='monthly'" v-bind:style="{ fontSize:'24px',fontWeight:'600 !important',color:'#000000' }">฿ 990
              <sapn  v-bind:style="{ fontSize:'14px',color:'#215295' }">{{ this.lg_header_feature.subtitlefree }}</sapn>
            </h3>
            <h3 v-else v-bind:style="{ fontSize:'24px',fontWeight:'600 !important',color:'#000000' }">฿ 11,880
              <sapn  v-bind:style="{ fontSize:'14px',color:'#215295' }">{{ this.lg_header_feature.subtitlefree_2 }}</sapn>
            </h3>  
          </v-col>
        </v-row>

          <v-row>
           <v-col justify="center" align="center" cols="12">
            <h5 v-bind:style="{ fontSize:'16px',fontWeight:'200 !important',color:'#215295' }">{{ this.lg_header_feature.businessplan_details }}</h5> 
         </v-col>
        </v-row>

         <!-- <v-row>
           <v-col justify="center" align="center" cols="12">
            <h3 v-bind:style="{ fontSize:'18px',fontWeight:'600 !important',color:'#000000' }">{{ this.lg_header_feature.subtitlefree }}</h3> 
         </v-col>
        </v-row> -->

            <!-- <v-divider class="mt-2" color="gray" style="border-top:1px solid gray;"></v-divider> -->

             <!-- <v-row class="mt-2">
           <v-col justify="center" align="center" cols="12">
           <v-btn
                class="rounded-pill"
                v-bind:style="{ fontSize:'14px',fontWeight:'600 !important',backgroundColor:'#215295',color:'#ffffff' }"
                 height="30"
              >
              {{ this.lg_header_feature.explore_features }}
              </v-btn>
        </v-col>
        </v-row> -->

          <v-row class="mt-2">
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'16px',fontWeight:'500 !important',color:'#215295',textIndent: '-30px',paddingLeft: '40px' }">
            <v-icon color="#215295">mdi-checkbox-marked-circle</v-icon> {{ this.lg_header_feature.titlebusinessplanoptions1 }}
        </v-col>
        </v-row>
          <v-row >
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'16px',fontWeight:'500 !important',color:'#215295',textIndent: '-30px',paddingLeft: '40px' }">
            <v-icon color="#215295">mdi-checkbox-marked-circle</v-icon> {{ this.lg_header_feature.titlebusinessplanoptions2 }}
        </v-col>
        </v-row>
          <v-row >
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'16px',fontWeight:'500 !important',color:'#215295',textIndent: '-30px',paddingLeft: '40px' }">
            <v-icon color="#215295">mdi-checkbox-marked-circle</v-icon> {{ this.lg_header_feature.titlebusinessplanoptions3 }}
        </v-col>
        </v-row>
          <v-row >
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'16px',fontWeight:'500 !important',color:'#215295',textIndent: '-30px',paddingLeft: '40px' }">
            <v-icon color="#215295">mdi-checkbox-marked-circle</v-icon> {{ this.lg_header_feature.titlebusinessplanoptions4 }}
        </v-col>
        </v-row>

        <v-row class="mt-2" justify="center" align="center">
          <v-card-actions class="card-actions">
         <v-row>
           <v-col justify="center" align="center" cols="12">
            <!-- @click="PaycheckoutPro('business')" -->
          <v-btn
                 elevation="2"
                 outlined
                v-bind:style="{ fontSize:'14px',fontWeight:'600 !important',backgroundColor:'#ffffff !important',color:'#215295',marginBottom:'10px' }"
                height="35"
                width="200"
                class="slide-btn"
              >
              {{ this.lg_header_feature.coming_soon }}
              </v-btn>
        </v-col>
        </v-row>
        </v-card-actions>
        </v-row>
          </v-card-text>
        </v-card>
      </v-col>

       <!-- plan custom -->
      <!-- <v-col  cols="12" sm="6" md="3">
        <v-card color="#215295" class="mx-6 mx-md-0 hover-zoom card-outter" elevation="4" style="border-radius:30px;border:thin solid #215295;" :min-height="card_height">
          <v-card-text align="center" justify="center">
            <v-row>
           <v-col justify="center" align="center" cols="12">
            <h3 v-bind:style="{ fontSize:'20px',fontWeight:'600 !important',color:'#ffffff' }">{{ this.lg_header_feature.titlecusstomplan }}</h3> 
             </v-col>
        </v-row>

          <v-row>
           <v-col justify="center" align="center" cols="12">
            <h3 v-bind:style="{ fontSize:'24px',fontWeight:'600 !important',color:'#ffffff' }">{{ this.lg_header_feature.title_custom }}</h3> 
          </v-col>
        </v-row>

         <v-row>
           <v-col justify="center" align="center" cols="12">
            <h3 v-bind:style="{ fontSize:'18px',fontWeight:'600 !important',color:'#ffffff' }">{{ this.lg_header_feature.subtitlefree }}</h3> 
         </v-col>
        </v-row>

            <v-divider class="mt-2" color="#ffffff" style="border-top:1px solid #ffffff;"></v-divider>

             <v-row class="mt-2">
           <v-col justify="center" align="center" cols="12">
           <v-btn
                class="rounded-pill"
                v-bind:style="{ fontSize:'14px',fontWeight:'600 !important',color:'#000000' }"
                 height="30"
              >
              {{ this.lg_header_feature.explore_features }}
              </v-btn>
        </v-col>
        </v-row>

          <v-row class="mt-2">
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'16px',fontWeight:'500 !important',color:'#ffffff',textIndent: '-30px',paddingLeft: '40px' }">
            <v-icon color="white">mdi-checkbox-marked-circle</v-icon> {{ this.lg_header_feature.titlecusstomplanoptions1 }}
        </v-col>
        </v-row>
          <v-row >
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'16px',fontWeight:'500 !important',color:'#ffffff',textIndent: '-30px',paddingLeft: '40px' }">
            <v-icon color="white">mdi-checkbox-marked-circle</v-icon> {{ this.lg_header_feature.titlecusstomplanoptions2 }}
        </v-col>
        </v-row>
          <v-row >
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'16px',fontWeight:'500 !important',color:'#ffffff',textIndent: '-30px',paddingLeft: '40px' }">
            <v-icon color="white">mdi-checkbox-marked-circle</v-icon> {{ this.lg_header_feature.titlecusstomplanoptions3 }}
        </v-col>
        </v-row>

         <v-row class="mt-2" justify="center" align="center">
        <v-card-actions class="card-actions">
         <v-row>
           <v-col justify="center" align="center" cols="12">
           <v-btn
                 elevation="2"
                v-bind:style="{ fontSize:'14px',fontWeight:'600 !important',color:'#000000' }"
                height="35"
                width="150"
                  @click="onClickMenu('/contact')"
              >
              {{ this.lg_header_feature.buttonpro }}
              </v-btn>
        </v-col>
        </v-row>
        </v-card-actions>
        </v-row>
          </v-card-text>
        </v-card>
      </v-col> -->
    </v-row>

        <v-row class="mx-6 homepricing_paragraph mt-12" justify="center" >
      <v-col align="center" justify="center" cols="12">
     <v-card
    outlined
    rounded="lg"
    class="hover-zoom card-outter relative-card pa-12"
    elevation="4"
    style="border-radius:30px;"
  >
    <v-row >
      <!-- Left: Text Content -->
      <v-col cols="12" md="7" class="" align="left">
        <v-card-title class="pa-0 mb-3 ">
         <h2 class="section-title">{{ this.lg_header_feature.titlecusstomplan }}</h2> 
        </v-card-title>
 
        <v-card-text class="pa-0 mb-4">
         <p class="section-desc" v-bind:style="{ color:'#215295' }">{{ this.lg_header_feature.enterpriseplan_details }}</p> 
        </v-card-text>
 
        <v-card-actions class="pa-0">
        <v-row class="ma-0 ":justify="$vuetify.breakpoint.smAndDown ? 'center' : 'start'">
             <div class="get-started-wrapper show" >
              <a @click="onClickMenu('/contact')"  class="get-started-link"> {{ this.lg_header_feature.buttonenterprise }} &gt;</a>
            </div>
            </v-row>
        </v-card-actions>
      </v-col>
 
      <!-- Right: Illustration -->
      <v-col cols="12" md="5" class="d-flex justify-center justify-md-end">
        <div class="illustration-wrapper">
          <!-- Clipboard / Checklist -->
          <svg width="180" height="150" viewBox="0 0 220 170" fill="none" xmlns="http://www.w3.org/2000/svg">
            <!-- Server stack (back right) -->
            <rect x="128" y="55" width="52" height="12" rx="3" fill="#E3EEFE" stroke="#A8C4F5" stroke-width="1.5"/>
            <rect x="128" y="71" width="52" height="12" rx="3" fill="#E3EEFE" stroke="#A8C4F5" stroke-width="1.5"/>
            <rect x="128" y="87" width="52" height="12" rx="3" fill="#E3EEFE" stroke="#A8C4F5" stroke-width="1.5"/>
            <circle cx="170" cy="61" r="2" fill="#5B9BF5"/>
            <circle cx="175" cy="61" r="2" fill="#5B9BF5"/>
            <circle cx="170" cy="77" r="2" fill="#5B9BF5"/>
            <circle cx="175" cy="77" r="2" fill="#5B9BF5"/>
            <circle cx="170" cy="93" r="2" fill="#5B9BF5"/>
            <circle cx="175" cy="93" r="2" fill="#5B9BF5"/>
 
            <!-- Laptop (bottom left) -->
            <rect x="10" y="55" width="90" height="58" rx="4" fill="#EEF3FB" stroke="#BDD1F8" stroke-width="1.5"/>
            <rect x="16" y="61" width="78" height="46" rx="2" fill="#D8E7FD"/>
            <!-- Bar chart inside laptop -->
            <rect x="28" y="88" width="8" height="12" rx="1" fill="#5B9BF5"/>
            <rect x="40" y="80" width="8" height="20" rx="1" fill="#5B9BF5"/>
            <rect x="52" y="84" width="8" height="16" rx="1" fill="#93BFFA"/>
            <rect x="64" y="76" width="8" height="24" rx="1" fill="#5B9BF5"/>
            <!-- Pie chart circle -->
            <circle cx="79" cy="80" r="9" fill="none" stroke="#BDD1F8" stroke-width="2"/>
            <!-- <path d="M79 120 L79 111 A9 9 0 0 1 87.7 124.5 Z" fill="#5B9BF5"/> -->
            <!-- Laptop base -->
            <rect x="8" y="113" width="90" height="6" rx="3" fill="#D0DEF5" stroke="#BDD1F8" stroke-width="1.5"/>
 
            <!-- Clipboard (center) -->
            <rect x="58" y="10" width="72" height="90" rx="5" fill="white" stroke="#BDD1F8" stroke-width="1.8"/>
            <!-- Clipboard top clip -->
            <rect x="82" y="5" width="24" height="14" rx="4" fill="#D0DEF5" stroke="#A8C4F5" stroke-width="1.5"/>
            <!-- Check lines -->
            <!-- Row 1 -->
            <circle cx="74" cy="38" r="7" fill="none" stroke="#A8C4F5" stroke-width="1.5"/>
            <polyline points="70,38 73,41 79,34" stroke="#5B9BF5" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            <line x1="84" y1="38" x2="118" y2="38" stroke="#D0DEF5" stroke-width="2" stroke-linecap="round"/>
            <!-- Row 2 -->
            <circle cx="74" cy="55" r="7" fill="none" stroke="#A8C4F5" stroke-width="1.5"/>
            <polyline points="70,55 73,58 79,51" stroke="#5B9BF5" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            <line x1="84" y1="55" x2="118" y2="55" stroke="#D0DEF5" stroke-width="2" stroke-linecap="round"/>
            <!-- Row 3 -->
            <circle cx="74" cy="72" r="7" fill="none" stroke="#A8C4F5" stroke-width="1.5"/>
            <polyline points="70,72 73,75 79,68" stroke="#5B9BF5" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            <line x1="84" y1="72" x2="118" y2="72" stroke="#D0DEF5" stroke-width="2" stroke-linecap="round"/>
 
            <!-- Shield (overlapping front) -->
            <path d="M105 90 C105 90 85 80 85 65 L85 52 L105 46 L125 52 L125 65 C125 80 105 90 105 90Z" fill="#2B7EF5" stroke="white" stroke-width="2"/>
            <polyline points="96,68 102,74 115,60" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </v-col>
    </v-row>
  </v-card>
  </v-col>
     </v-row>

    <v-row class="mx-6 mx-md-0 mt-4 homepricing_paragraph" justify="center" >
      <v-col align="center" justify="center"  cols="12" xl="12" lg="12" md="12" sm="12" xs="12" >
          <!-- <h1 class="display-6 fw-bold lh-1 mb-3" v-bind:style="{ fontSize:'38px' }">
            {{this.lg_header_feature.title_plan}}
          </h1> -->
          <br />
 <table style="border-radius:10px;overflow: hidden;" class="elevation-1 ">
  <thead>
    <tr>
      <th></th>
      <th>{{ this.lg_header_feature.titlefree}}</th>
      <!-- <br>฿390{{ this.lg_header_feature.subtitlefree }} -->
      <th>{{ this.lg_header_feature.titlepro}}</th>
      <!-- <br>฿990{{ this.lg_header_feature.subtitlefree }} -->
      <th>{{ this.lg_header_feature.titlebusiness}}</th>
      <!-- <br>{{ this.lg_header_feature.title_custom}}{{ this.lg_header_feature.subtitlefree }} -->
      <th>{{ this.lg_header_feature.titleenterprise}}</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>{{ this.lg_header_feature.header_table1}}</td>
      <td data-label="Free">{{ this.lg_header_feature.up_to_ten}}</td>
      <td data-label="Pro">{{ this.lg_header_feature.up_to_fifty}}</td>
      <td data-label="Business">{{ this.lg_header_feature.up_to_hundred}}</td>
      <td data-label="Enterprise">{{ this.lg_header_feature.unlimited}}</td>
    </tr>
    <tr>
      <td>{{ this.lg_header_feature.header_table2}}</td>
      <td data-label="Free">{{ this.lg_header_feature.minite_per_session}}</td>
      <td data-label="Pro">{{ this.lg_header_feature.unlimited}}</td>
      <td data-label="Business">{{ this.lg_header_feature.unlimited}}</td>
      <td data-label="Enterprise">{{ this.lg_header_feature.unlimited}}</td>
    </tr>
    <tr>
      <td>{{ this.lg_header_feature.header_table3}}</td>
      <td data-label="Free">-</td>
      <td data-label="Pro">{{ this.lg_header_feature.sixty_minute_per_month}}</td>
      <td data-label="Business">{{ this.lg_header_feature.hundred_twenty_minute_per_month}}</td>
      <td data-label="Enterprise">{{ this.lg_header_feature.title_custom}}</td>
    </tr>
    <tr>
      <td>{{ this.lg_header_feature.header_table4}}</td>
      <td data-label="Free">-</td>
      <td data-label="Pro">{{ this.lg_header_feature.record_bath_per_min}}</td>
      <td data-label="Business">{{ this.lg_header_feature.record_bath_per_min}}</td>
      <td data-label="Enterprise">{{ this.lg_header_feature.discounted_rate}}</td>
    </tr>
    <tr>
      <td>{{ this.lg_header_feature.header_table5}}</td>
      <td data-label="Free"><span class="check"><v-icon color="green">mdi-checkbox-marked-circle</v-icon></span></td>
      <td data-label="Pro"><span class="check"> <v-icon color="green">mdi-checkbox-marked-circle</v-icon></span></td>
      <td data-label="Business"><span class="check"> <v-icon color="green">mdi-checkbox-marked-circle</v-icon></span></td>
      <td data-label="Enterprise"><span class="check"> <v-icon color="green">mdi-checkbox-marked-circle</v-icon></span></td>
    </tr>
    <tr>
      <td>{{ this.lg_header_feature.header_table6}}</td>
      <td data-label="Free"><span class="cross"><v-icon color="red">mdi-close-circle</v-icon></span></td> 
      <td data-label="Pro"><span class="cross"><v-icon color="red">mdi-close-circle</v-icon></span></td>
      <td data-label="Business"><span class="check"> <v-icon color="green">mdi-checkbox-marked-circle</v-icon></span></td>
      <td data-label="Enterprise"><span class="check"> <v-icon color="green">mdi-checkbox-marked-circle</v-icon></span></td>
    </tr>
    <tr>
      <td>{{ this.lg_header_feature.header_table7}}</td>
      <td data-label="Free"><span class="cross"><v-icon color="red">mdi-close-circle</v-icon></span></td>
      <td data-label="Pro"><span class="cross"><v-icon color="red">mdi-close-circle</v-icon></span></td>
      <td data-label="Business"><span class="check"> <v-icon color="green">mdi-checkbox-marked-circle</v-icon></span></td>
      <td data-label="Enterprise"><span class="check"> <v-icon color="green">mdi-checkbox-marked-circle</v-icon></span></td>
    </tr>
    <tr>
      <td>{{ this.lg_header_feature.header_table8}}</td>
      <td data-label="Free"><span class="cross"><v-icon color="red">mdi-close-circle</v-icon></span></td>
      <td data-label="Pro"><v-icon color="red">mdi-close-circle</v-icon></td>
      <td data-label="Business"><span class="cross"><v-icon color="red">mdi-close-circle</v-icon></span></td>
      <td data-label="Enterprise"><span class="check"> <v-icon color="green">mdi-checkbox-marked-circle</v-icon></span></td>
    </tr>
    <tr>
      <td>{{ this.lg_header_feature.header_table9}}</td>
      <td data-label="Free"> <v-icon color="green">mdi-checkbox-marked-circle</v-icon></td>
      <td data-label="Pro"> <v-icon color="green">mdi-checkbox-marked-circle</v-icon></td>
      <td data-label="Business"><span class="check"> <v-icon color="green">mdi-checkbox-marked-circle</v-icon></span></td>
      <td data-label="Enterprise"><span class="check"> <v-icon color="green">mdi-checkbox-marked-circle</v-icon></span></td>
    </tr>
    <tr>
      <td>{{ this.lg_header_feature.header_table10}}</td>
      <td data-label="Free">{{ this.lg_header_feature.basic_email}}</td>
      <td data-label="Pro">{{ this.lg_header_feature.standard_email}}</td>
      <td data-label="Business">{{ this.lg_header_feature.priority}}</td>
      <td data-label="Enterprise">{{ this.lg_header_feature.dedicated}}</td>
    </tr>
    <tr>
      <td>{{ this.lg_header_feature.header_table11}}</td>
      <td data-label="Free">-</td>
      <td data-label="Pro">{{ this.lg_header_feature.bath_per_meeting}}</td>
      <td data-label="Business">{{ this.lg_header_feature.bath_per_meeting}}</td> 
      <td data-label="Enterprise">{{ this.lg_header_feature.discounted_rate}}</td>
    </tr>
        <tr>
      <td></td>
      <td data-label="Free">
          <v-btn
                 elevation="2"
                 v-bind:style="{ fontSize:'14px',fontWeight:'600 !important',backgroundColor:'#215295 !important',color:'#ffffff',
                 width: $vuetify.breakpoint.xs ? '120px' : '150px' }"
                 height="35"
                 class="slide-btn"
                  @click="onClickMenu('/register-account')"
              >
              {{ this.lg_header_feature.btn_signup }}
              </v-btn>
      </td>
      <td data-label="Pro">
        <v-btn
                 elevation="2"
                 outlined
                v-bind:style="{ fontSize:'14px',fontWeight:'600 !important',backgroundColor:'#ffffff !important',color:'#215295' ,
                 width: $vuetify.breakpoint.xs ? '120px' : '150px' }"
                height="35"
                width="150"
                class="slide-btn"
              >
              {{ this.lg_header_feature.coming_soon }}
              </v-btn>
      </td>
      <td data-label="Business">
        <v-btn
                 elevation="2"
                 outlined
                v-bind:style="{ fontSize:'14px',fontWeight:'600 !important',backgroundColor:'#ffffff !important',color:'#215295' ,
                 width: $vuetify.breakpoint.xs ? '120px' : '150px' }"
                height="35"
                width="150"
                class="slide-btn"
              >
              {{ this.lg_header_feature.coming_soon }}
              </v-btn>
      </td> 
      <td data-label="Enterprise">
        <v-btn
                 elevation="2"
                 outlined
                v-bind:style="{ fontSize:'14px',fontWeight:'600 !important',backgroundColor:'#ffffff !important',color:'#215295' ,
                 width: $vuetify.breakpoint.xs ? '120px' : '150px' }"
                height="35"
                width="150"
                class="slide-btn"
                @click="onClickMenu('/contact')"
              >
              {{ this.lg_header_feature.buttonpro }}
              </v-btn>
      </td>
    </tr>

    
  </tbody>
</table>
      </v-col>
    </v-row>

    <v-row class="" justify="center" v-bind:style="{ align:'center'}">
       <v-card color="#FFFFFF" class="homepricing_paragraph mb-16 ml-4 mr-4 mt-0 mt-sm-16" elevation="4" style="border-radius:30px;border:thin solid #d0d0d0;" :width="800">
      <v-row class="" justify="center" v-bind:style="{ align:'center'}">
        <v-col justify="center" cols="12" xl="12" lg="12" md="12" sm="12" xs="12" v-bind:style="{align:'center' }">
          <v-row justify="center" v-bind:style="{align:'center' }" >
          <h1 align="center" class=" lh-1 mb-3 mt-8 mx-6 mx-md-0 section-title" v-bind:style="{ color: '#000000'}">
            {{ this.lg_header_feature.title_additional_information }}
          </h1>
           </v-row>
      </v-col>
      <v-col align="center" cols="12" xl="12" lg="12" md="512" sm="12" xs="12" v-bind:style="{align:'center'}" class="px-12">
             <v-list class="transparent-background" > 
              <!-- color="#04182D" -->
               <v-divider class="mt-8"></v-divider>
      <v-list-group 
        no-action  
      append-icon="mdi-plus"
      >
        <template v-slot:activator>
          <v-list-item-content >
            <!-- v-text="lg_header_feature.question1" -->
            <v-list-item-title style="line-height: 2.2 !important;" class="black--text text-left section-desc">
              <!-- <sup class="text-caption">01</sup> -->
              {{ lg_header_feature.question1 }}</v-list-item-title>
          </v-list-item-content>
        </template>

         <v-list-item three-line style="padding: 0px;">
      <v-list-item-content >
        <v-list-item-title></v-list-item-title>
        <v-list-item-subtitle class="black--text wrap-text font-weight-light" style="text-align: left !important;">
          {{ this.lg_header_feature.subquestion1 }}
        </v-list-item-subtitle>
        <v-list-item-subtitle class="black--text wrap-text font-weight-light" style="text-align: left !important;">
          {{ this.lg_header_feature.subquestion1_2 }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
      </v-list-group>

       <v-divider></v-divider>

          <v-list-group
        no-action  
      append-icon="mdi-plus"
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title style="line-height: 2.2 !important;"  class="black--text text-left section-desc">
              <!-- <sup class="text-caption">02</sup> -->
              {{ lg_header_feature.question2 }}</v-list-item-title>
          </v-list-item-content>
        </template>

         <v-list-item three-line style="padding: 0px;">
      <v-list-item-content >
        <v-list-item-title></v-list-item-title>
        <v-list-item-subtitle class="black--text wrap-text font-weight-light" style="text-align: left !important;">
          {{ this.lg_header_feature.subquestion2 }}
        </v-list-item-subtitle>
                <v-list-item-subtitle class="black--text wrap-text font-weight-light" style="text-align: left !important;">
          {{ this.lg_header_feature.subquestion2_2 }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
      </v-list-group>
       <v-divider></v-divider>

                 <v-list-group
        no-action  
      append-icon="mdi-plus"
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title style="line-height: 2.2 !important;"  class="black--text text-left section-desc">
              <!-- <sup class="text-caption">03</sup> -->
              {{ lg_header_feature.question3 }}</v-list-item-title>
          </v-list-item-content>
        </template>

         <v-list-item three-line style="padding: 0px;">
      <v-list-item-content >
        <v-list-item-title></v-list-item-title>
        <v-list-item-subtitle class="black--text wrap-text font-weight-light" style="text-align: left !important;">
          {{ this.lg_header_feature.subquestion3 }}
        </v-list-item-subtitle>
        <ul class="text-left">
          <li> {{ this.lg_header_feature.subquestion3_2 }}</li>
        </ul>
        <ul class="text-left">
          <li> {{ this.lg_header_feature.subquestion3_3 }}</li>
        </ul>
      </v-list-item-content>
    </v-list-item>
      </v-list-group>
       <v-divider></v-divider>

                 <v-list-group
        no-action  
      append-icon="mdi-plus"
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title style="line-height: 2.2 !important;"  class="black--text text-left section-desc">
              <!-- <sup class="text-caption">04</sup> -->
              {{ lg_header_feature.question4 }}</v-list-item-title>
          </v-list-item-content>
        </template>

         <v-list-item three-line style="padding: 0px;">
      <v-list-item-content >
        <v-list-item-title></v-list-item-title>
        <v-list-item-subtitle class="black--text wrap-text font-weight-light" style="text-align: left !important;">
          {{ this.lg_header_feature.subquestion4 }}
        </v-list-item-subtitle>
                <v-list-item-subtitle class="black--text wrap-text font-weight-light" style="text-align: left !important;">
          {{ this.lg_header_feature.subquestion4_2 }}
        </v-list-item-subtitle>
                <!-- <v-list-item-subtitle class="black--text wrap-text font-weight-light" style="text-align: left !important;">
          {{ this.lg_header_feature.subquestion4_3 }}
        </v-list-item-subtitle> -->
      </v-list-item-content>
    </v-list-item>
      </v-list-group>

       <v-divider></v-divider>
    <v-list-group
        no-action  
      append-icon="mdi-plus"
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title style="line-height: 2.2 !important;"  class="black--text text-left section-desc">
              <!-- <sup class="text-caption">05</sup> -->
              {{ lg_header_feature.question5 }}</v-list-item-title>
          </v-list-item-content>
        </template>

         <v-list-item three-line style="padding: 0px;">
      <v-list-item-content >
        <v-list-item-title></v-list-item-title>
        <v-list-item-subtitle class="black--text wrap-text font-weight-light" style="text-align: left !important;">
          {{ this.lg_header_feature.subquestion5 }}
        </v-list-item-subtitle>
                <v-list-item-subtitle class="black--text wrap-text font-weight-light" style="text-align: left !important;">
          {{ this.lg_header_feature.subquestion5_2 }}
        </v-list-item-subtitle>
                        <v-list-item-subtitle class="black--text wrap-text font-weight-light" style="text-align: left !important;">
          {{ this.lg_header_feature.subquestion5_3 }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
      </v-list-group>
 <v-divider></v-divider>
        <!-- <v-divider></v-divider>
    <v-list-group
        no-action  
      append-icon="mdi-plus"
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title style="line-height: 2.2 !important;"  class="black--text text-left text-sm-h5"><sup class="text-caption">06</sup>{{ lg_header_feature.question6 }}</v-list-item-title>
          </v-list-item-content>
        </template>

         <v-list-item three-line style="padding: 0px;">
      <v-list-item-content >
        <v-list-item-title></v-list-item-title>
        <v-list-item-subtitle class="black--text wrap-text font-weight-light" style="text-align: left !important;">
          {{ this.lg_header_feature.subquestion6 }}
        </v-list-item-subtitle>
                <v-list-item-subtitle class="black--text wrap-text font-weight-light" style="text-align: left !important;">
          {{ this.lg_header_feature.subquestion6_2 }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
      </v-list-group>

        <v-divider></v-divider>
    <v-list-group
        no-action  
      append-icon="mdi-plus"
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title style="line-height: 2.2 !important;"  class="black--text text-left text-sm-h5"><sup class="text-caption">07</sup>{{ lg_header_feature.question7 }}</v-list-item-title>
          </v-list-item-content>
        </template>

         <v-list-item three-line style="padding: 0px;">
      <v-list-item-content >
        <v-list-item-title></v-list-item-title>
        <v-list-item-subtitle class="black--text wrap-text font-weight-light" style="text-align: left !important;">
          {{ this.lg_header_feature.subquestion7 }}
        </v-list-item-subtitle>
                <v-list-item-subtitle class="black--text wrap-text font-weight-light" style="text-align: left !important;">
          {{ this.lg_header_feature.subquestion7_2 }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
      </v-list-group> -->

    </v-list>
      </v-col>
    </v-row>
     <v-card-actions class="pt-4">
         <v-row>
           <v-col justify="center" align="center" cols="12">
         <p class="section-desc">{{ this.lg_header_feature.still_have_questions }}</p> 
        </v-col>
           <v-col class="mt-n10" justify="center" align="center" cols="12">
         <p class="section-desc"><a @click="onClickMenu('/contact')"  class="get-started-link"> {{ this.lg_header_feature.contact_support }}</a></p> 
        </v-col>

        
        </v-row>
        </v-card-actions>
    </v-card>
    </v-row>
  </div>
   <LoadingDialog></LoadingDialog>
  </v-container>
</template>

<script>
import { server } from "../services/constants";
import { getByMeetNameOnly } from "@/services/api_meetroom";
import api from "@/services/api";
import { lg_header_feature } from "./language/lg_header_feature.js";
import { feature } from "../services/constants.js";
// import {loadStripe} from '@stripe/stripe-js';
import LoadingDialog from "@/components/cards/LoadingDialog";

export default {
  data: () => ({
    billing:"monthly",
    showcheckout:false,
     stripe: null,
      clientSecret: null,
    form: {
      meetId: undefined,
    },
    getlanguage:"",
     headers: [
        { text: "Feature", value: "feature" },
        { text: "Free", value: "free" },
        { text: "Pro ฿390/month", value: "pro" },
        { text: "Business ฿990/month", value: "business" },
        { text: "Enterprise Custom/Month", value: "enterprise" },
      ],
  }),
   components: {
      LoadingDialog,
    },
  methods: {
   async PaycheckoutPro(plan_name){
    localStorage.setItem(feature.GET_BUY_NOW, `${plan_name}`);
     this.$router.push(`/register-account`);
     return;
    try {
      this.$store.state.loadMenu = true;
//       setTimeout(() => {
//    this.$store.state.loadMenu = false;
// }, 2000);

      // return;
      // const stripe = await loadStripe('pk_test_51Nn1nlAXAFZfMq9NdFPD4Cignl0WpECylmPArkIZdUyPIcTGslmJRgvXPSkQfaooK43d2oXkyol1HHolnXsXu2uU00fI8sGL19');
    const result =  await api.checkoutstripepayment({plan:plan_name});
     this.$store.state.loadMenu = false;
    console.log(result);
    this.clientSecret = result.data.checkoutSessionID;
    // this.clientSecret = result.data.clientSecret;
    this.$router.push(`/checkout-session/${this.clientSecret}`);
    return;
    // this.stripe = window.Stripe("pk_test_51Nn1nlAXAFZfMq9NdFPD4Cignl0WpECylmPArkIZdUyPIcTGslmJRgvXPSkQfaooK43d2oXkyol1HHolnXsXu2uU00fI8sGL19");
   
    this.showcheckout = true;
     const checkout = await this.stripe.initEmbeddedCheckout({
          clientSecret: this.clientSecret
        });
          
         checkout.mount("#checkout");
        this.$store.state.loadMenu = false;
         } catch (err) {
           this.$store.state.loadMenu = false;
          //  this.showcheckout = false;
        console.error("Stripe Checkout error:", err);
      }

    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    onClickMenu(link) {
      this.$router.push(link).catch((err) => {});
    },
    
  },
   computed: {
     card_height() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 570;
        case "sm":
          return 470;
        case "md":
          return 570;
        case "lg":
          return 520;
        case "xl":
          return 430;
           }
    },
  buttonsmall() {
     if(this.$vuetify.breakpoint.name === "xs"){
       return true;
     }
      },
      widthheightimage(){
 switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "350";
        case "sm":
          return "450";
        case "md":
          return "450";
        case "lg":
          return "500";
        case "xl":
          return "500";
      }
      },
    widthbutton() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "40%";
        case "sm":
          return "25%";
        case "md":
          return "25%";
        case "lg":
          return "25%";
        case "xl":
          return "20%";
      }
    },
    },
   async beforeCreate() {
      this.$store.state.page_reload = false;
      // alert(localStorage.getItem("language"))
      // console.log("language login : " + localStorage.getItem(feature.LANGUAGE));
      localStorage.getItem(feature.LANGUAGE) === "th"
        ? this.lg_header_feature = lg_header_feature.lg_header_feature_th
        : this.lg_header_feature = lg_header_feature.lg_header_feature_en;

        // console.log("lg_login: " + JSON.stringify(this.lg_login));
    },
    async mounted(){
      this.$store.state.loadFooter = true;
      const userId = localStorage.getItem(server.USER_ID);
       if (userId && api.isLoggedIn()) {
      this.$router.push("/listroom");
      return;
    }
      // this.stripe = await loadStripe('pk_test_51Nn1nlAXAFZfMq9NdFPD4Cignl0WpECylmPArkIZdUyPIcTGslmJRgvXPSkQfaooK43d2oXkyol1HHolnXsXu2uU00fI8sGL19');
      this.getlanguage = localStorage.getItem(feature.LANGUAGE);
      const paragraphs = document.querySelectorAll(".homepricing_paragraph");
document.addEventListener("scroll", function(){
  paragraphs.forEach((paragraph)=>{
    if(isInView(paragraph)){
      paragraph.classList.add("homepricing_paragraph--visible")
    }
  })
});

const titleElbtngetstart_paragraphs = document.querySelectorAll(".btngetstart_paragraph");
if (titleElbtngetstart_paragraphs.length > 0) {
  titleElbtngetstart_paragraphs.forEach((el, index) => {
    setTimeout(() => {
      el.classList.add("btngetstart_paragraph--visible");
    }, 200 + index * 150); // delay ทีละตัว ให้ดู smooth ขึ้น
  });
}

function isInView(element){
const rect = element.getBoundingClientRect();
return(
  rect.bottom > 0 &&
  rect.top < (window.innerHeight -100  || document.documentElement.clientHeight - 100 )
)
}
    },
};
</script>

<style scoped>
.textinform{
  width:75%;
}
@media (max-width: 599px) {
  .joinmeeting-container {
    margin-top:-150px;
  }
  .v-main {
    margin-top:-50px;
    height: 110% !important;
  }
}
@media (max-width: 959px) {
  .joinmeeting-container {
    margin-top:-180px !important;
  }
}

@media (min-width: 1260px) {
  .joinmeeting-container {
    margin-top: 5rem;
  }
  
}

.v-main {
    max-width: 100%;
    height: 100%;
    width: 100%;
    background-image: linear-gradient(to right bottom, #b3c8ee, #b2c9f0, #b1c9f3, #b0caf5, #afcbf8) !important;
}
.joinmeeting-container {
    margin-top: -10px;
  }

  .homepricing_paragraph{
  transform: translateY(20px);
  opacity: 0;
  transition: 2s ease;
}
.homepricing_paragraph--visible{
  transform: translateY(0);
  opacity: 1;
}

.hover-zoom:hover {
  transform: scale(1.07);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}
.relative-card {
  position: relative;
}

.icon-top-right {
  position: absolute;
  top: -16px;
  /* right:20px;  */
  left: 50%;
  transform: translateX(-50%);
  background: white;
  cursor: pointer;
  z-index: 10;
}
.card-outter {
  padding-bottom:10px;
  padding-top:10px;
}
.card-actions {
  position: absolute;
  bottom: 0;
  justify-self: center;
}
table tr > th {
  border-top:thin solid #dddddd;
  text-align-last: center;
  /* background: lightgray; */
}

table tr > th:first-child {
    border-left: thin solid #dddddd;
}

table tr > th:last-child {
    border-right: thin solid #dddddd;
}

table tr > td:first-child {
  border-top:thin solid #dddddd;
  /* border-bottom:thin solid #dddddd; */
  /* background: lightgray; */
  text-align-last: center;
}
table tr > td {
  /* border:thin solid #dddddd; */
  text-align-last: center;
  /* background: lightgray; */
}
 table {
      width: 100%;
      border-collapse: collapse;
      /* box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); */
      box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12) !important;
    }


    thead th {
      /* background-color: #e0efff; */
      /* background-color: #FFFFFF; */
      color: #000;
      font-size: 18px;
      padding: 16px;
      text-align: center;
      /* border: 1px solid #ccc; */
      border-top:thin solid #ccc;
      border-bottom:thin solid #ccc;
    }

    /* thead th:nth-child(2) { background-color: #cfe5ff; }
    thead th:nth-child(3) { background-color: #a9cdfd; }
    thead th:nth-child(4) { background-color: #5F98D9; }
    thead th:nth-child(5) { background-color: #3173B5; color: #000000; } */
        thead th:nth-child(2) { background-color: #FFFFFF; }
    thead th:nth-child(3) { background-color: #FFFFFF; }
    thead th:nth-child(4) { background-color: #FFFFFF; }
    thead th:nth-child(5) { background-color: #FFFFFF; color: #000000; }

    tbody td {
      padding: 12px;
      text-align: center;
      /* border: 1px solid #ddd; */
      border-top:thin solid #ccc;
      border-bottom:thin solid #ccc;
      font-size: 15px;
      color: #215295 !important;
    }

    tbody td:first-child {
      text-align: left;
      /* background-color: #f8f8f8; */
      font-weight: bold;
      border-left: thin solid #ddd;
    }

        tbody td:last-child {
      text-align: left;
      /* background-color: #f8f8f8; */
      border-right: thin solid #ddd;
    }


    .check {
      color: green;
      /* font-size: 20px; */
    }

    .cross {
      color: red;
      font-size: 20px;
    }

    /* Responsive styles */
    @media (max-width: 768px) {
      table, thead, tbody, th, td, tr {
        display: block;
      }

      thead {
        display: none;
      }

      tbody tr {
        margin-bottom: 20px;
        border: thin solid #ccc;
        border-radius: 10px;
        overflow: hidden;
        background-color: #fff;
        padding: 10px;
      }

      tbody td {
        text-align: right;
        position: relative;
        padding-left: 50%;
        border: none;
        border-bottom: thin solid #eee;
      }

      tbody td:first-child {
        background-color: #f0f0f0;
        font-weight: bold;
        text-align: left;
        padding-left: 10px;
        border-bottom: none;
      }

      tbody td::before {
        content: attr(data-label);
        position: absolute;
        left: 10px;
        width: 45%;
        padding-left: 10px;
        font-weight: bold;
        text-align: left;
        white-space: nowrap;
      }
      table tr > th:first-child {
   border-left: 0px solid #dddddd;
    }
    tbody td:first-child {
      border-left: 0px solid #ddd;
    }

    table tr > th:last-child {
   border-right: 0px solid #dddddd;
    }
        tbody td:last-child {
      border-right: 0px solid #ddd;
    }
    }

    .get-started-link {
  font-size: 16px;
  font-weight: 600;
  color: #215295 !important;
  text-decoration: none;
}
 
.get-started-link:hover {
  text-decoration: underline;
}

.btngetstart_paragraph {
  opacity: 0;
  transform: translateY(60px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.btngetstart_paragraph--visible {
  opacity: 1;
  transform: translateY(0);
}

.billing-toggle {
  background-color: #eaf1fb !important; /* track สีฟ้าอ่อน */
  /* border-radius: 999px !important; */
  padding: 10px !important;
  box-shadow: none !important;
}

/* ปุ่มปกติ */
.billing-btn {
  /* border-radius: 999px !important; */
  border: none !important;
  background-color: transparent !important;
  color: #000000 !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  min-width: 100px !important;
  box-shadow: none !important;
}

/* ปุ่ม Active — สีขาว + shadow */
.billing-toggle .billing-btn.v-btn--active {
  background-color: #ffffff !important;
  color: #1a2b4a !important;
  border-radius: 8px !important;
   font-weight: 600 !important;
}

/* override สี overlay ที่ Vuetify ใส่ให้ */
.billing-toggle .billing-btn.v-btn--active::before {
  opacity: 0 !important;
}
</style>
